import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GraduationCap, Mail } from 'lucide-react';
import { useTheme } from '@/context/ThemeContext';

const Footer = () => {
  const navigate = useNavigate();
  const { isDarkMode } = useTheme();

  return (
    <footer className={`${isDarkMode ? 'bg-black text-amber-100 border-amber-900/50' : 'bg-amber-900 text-amber-100'} py-12 mt-auto border-t`}>
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* Brand */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <GraduationCap className={`w-6 h-6 ${isDarkMode ? 'text-amber-500' : 'text-amber-300'}`} />
              <span className="text-xl font-bold">Lyceum</span>
            </div>
            <p className={`${isDarkMode ? 'text-amber-300' : 'text-amber-200'} text-sm`}>
              AI-powered history education for curious minds.
            </p>
          </div>

          {/* Product */}
          <div>
            <h3 className="font-semibold text-white mb-4">Product</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => {
                    navigate('/courses');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-amber-200 hover:text-white transition-colors"
                >
                  Courses
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    navigate('/chat');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-amber-200 hover:text-white transition-colors"
                >
                  History Chat Room
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    navigate('/debate');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-amber-200 hover:text-white transition-colors"
                >
                  Debate Room
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    navigate('/subscription');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-amber-200 hover:text-white transition-colors"
                >
                  Pricing
                </button>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="font-semibold text-white mb-4">Support</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => {
                    navigate('/help');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-amber-200 hover:text-white transition-colors"
                >
                  Help Center
                </button>
              </li>
              <li>
                <a
                  href="mailto:help@mylyceum.org"
                  className="text-amber-200 hover:text-white transition-colors flex items-center gap-1"
                >
                  <Mail className="w-3 h-3" />
                  Contact Us
                </a>
              </li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="font-semibold text-white mb-4">Legal</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <button
                  onClick={() => {
                    navigate('/terms');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-amber-200 hover:text-white transition-colors"
                >
                  Terms of Service
                </button>
              </li>
              <li>
                <button
                  onClick={() => {
                    navigate('/privacy');
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                  }}
                  className="text-amber-200 hover:text-white transition-colors"
                >
                  Privacy Policy
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className={`border-t ${isDarkMode ? 'border-amber-900/50' : 'border-amber-800'} pt-8 text-center text-sm ${isDarkMode ? 'text-amber-400' : 'text-amber-300'}`}>
          <p>&copy; {new Date().getFullYear()} Lyceum. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
